






import { computed, defineComponent, onMounted } from '@vue/composition-api';
import DealroomApp from '@getaccept/dsr-published-site/src/App.vue';
import { setMomentLocale } from '@getaccept/lib-shared/src/moment';
import SigningApp from './App.vue';
import UniversalLinkLobby from './universal-link/components/UniversalLinkLobby.vue';
import { loadLanguageAsync, userLanguage } from './lang';
import ReportEmail from './report-email/components/ReportEmail.vue';

export default defineComponent({
  components: {
    DealroomApp,
    SigningApp,
    UniversalLinkLobby,
    ReportEmail,
  },
  setup() {
    const isDsr = computed(() => window.location.pathname.includes('/dsr'));

    const isUniversalLink = computed(() => !!window.location.href.includes('/share/d'));

    const isReportEmail = computed(() => !!window.location.href.includes('/report-email'));

    onMounted(() => {
      loadLanguageAsync(userLanguage());
      setMomentLocale(userLanguage());
    });

    return {
      isDsr,
      isUniversalLink,
      isReportEmail,
    };
  },
});
